const legalConfig = {
    institutionName: 'Secundaria Babeque',
    legalName: 'FUNDACION PEDAGOGICA DOMINICANA',
    rnc: '401047209',
    address: 'AVENIDA ROBERTO PASTORIZA, NO. 329, SECTOR NACO, SANTO DOMINGO DE GUZMAN, REPÚBLICA DOMINICANA',
    phone: '809-381-2673',
    privacyEmail: 'info@secundariababeque.edu.do',
    privacyArea: 'Dirección Administrativa',
    effectiveDate: '21 de agosto de 2026',
    lastUpdated: '21 de agosto de 2026',
    metaService: 'WhatsApp Business Platform (WABA) de Meta',
    whatsappRetention: 'doce (12) meses después de la última interacción',
    deletionAcknowledgement: 'cinco (5) días hábiles',
    deletionCompletion: 'quince (15) días hábiles'
};

export default legalConfig;
